export default __webpack_public_path__ + "static/post2-0422a4b90f255abfe43b6d8addf0cae1.jpg";